export const ADMIN_ROLE = 'practiceManager';
export const BILLER_ROLE = 'biller';
export const USER_ROLE = 'user';
export const DEFAULT_INITIAL_PAGE = [
  { role: ADMIN_ROLE, page: 'patients' },
  { role: BILLER_ROLE, page: 'billing' },
  { role: USER_ROLE, page: 'patients' },
];
